exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#createWrapper[data-v-46d92fa4]{margin-top:15%}#formHeading[data-v-46d92fa4]{font-family:Lato,sans-serif;font-size:24px;font-weight:400}input[data-v-46d92fa4]{padding:10px;font-size:13px;box-shadow:2px 2px 10px #919191;margin-top:3%}#createButton[data-v-46d92fa4]{font-family:Lato,sans-serif;font-size:20px;width:fit-content;margin:0 auto;margin-top:3%;transition-duration:.4s}.readyToCreate[data-v-46d92fa4]{padding:10px;background-color:#6d6d6d;box-shadow:2px 2px 10px #919191;color:#fffaf0;cursor:pointer}.readyToCreate[data-v-46d92fa4]:hover{transform:scale(.9)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46d92fa4","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Create.vue
// module id = 173
// module chunks = 0